// extracted by mini-css-extract-plugin
export default {"menu":"spKVdME1GFGaedGgD5L_","dropdown":"b1ujsdn4wT6lO8kWtQFO"};